
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { getI18nStaticPaths, getI18nStaticProps } from 'modules/i18n/server';
import { InferGetStaticPropsType } from 'next';
import { Mdx } from 'modules/i18n';
import HeaderLayout from 'modules/common/layouts/HeaderLayout';
import React from 'react';
import SEO from 'modules/App/components/SEO';
import usePublicRuntimeConfig from 'modules/common/hooks/usePublicRuntimeConfig';
function StaticPage({ mdxContent, imageSizes }: InferGetStaticPropsType<typeof getStaticProps>) {
    const { frontmatter = {} } = mdxContent || {};
    const publicRuntimeConfig = usePublicRuntimeConfig();
    return (<HeaderLayout title={frontmatter['title'] as string} description={frontmatter['description'] as string}>
      <SEO />
      <article className="boxed--sm prose mx-auto my-5 sm:my-12 min-h-[300px]">
        {mdxContent && <Mdx {...mdxContent} imageSizes={imageSizes} scope={{ ...publicRuntimeConfig }}/>}
      </article>
    </HeaderLayout>);
}
export const getStaticPaths = getI18nStaticPaths('pages');
const getStaticProps = getI18nStaticProps('pages');
export default StaticPage;

    async function __Next_Translate__getStaticProps__197dae1f0d3__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/[...paths]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__197dae1f0d3__ as getStaticProps }
  